<template>
  <div :class="width">
    <div class="modal-lecard" :class="{'modal-lecard__open': modalOpen}">
      <form @submit.prevent="salvarModal">
        <div class="modal__inner">
          <div class="modal-lecard__container">
            <div class="container">
              <slot></slot>
            </div>
          </div>
          <div class="modal-lecard__footer border-top">
            <button type="button" class="btn btn-dark" @click="closeModal">
              {{preview ? 'Fechar' : 'Voltar'}}
            </button>
            <button type="submit" class="btn btn-primary ml-3" v-show="!preview">Salvar</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: ['preview', 'width'],
  data() {
    return {
      modalOpen: false
    }
  },
  methods: {
    closeModal() {
      document.body.classList.remove("modal-open");
      this.modalOpen = false;
      this.$emit('cancelar');
    },

    openModal() {
      document.body.classList.add("modal-open");
      this.modalOpen = true;
    },

    salvarModal() {
      this.$emit('salvar', (fechar) => {
        this.$emit('fechar');
        if (fechar) this.closeModal();
      });
    }
  },
  created() {
    this.$parent.$on('openModal', (id) => {
      this.openModal();
      this.$emit('loadDadosModal', id);
    });

    this.$parent.$on('closeModal', () => {
      this.closeModal();
    });
  }
}
</script>

<style scoped>
.modal-lecard {
  opacity: 0;
  visibility: hidden;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  text-align: left;
  background: rgba(0,0,0,.7);
  transition: opacity .25s ease;
  z-index: 1090;
}

.modal-lecard__open {
  opacity: 1;
  visibility: visible;
}

.modal__inner {
  transition: top .25s ease;
  position: absolute;
  top: 0;
  right: 0;
  left: auto;
  width: 55%;
  margin: auto;
  overflow: auto;
  background: #fff;
  height: 100%;
}

.modal-lecard__container {
  height: 90%;
  padding-top: 16px;
  overflow: auto;
  padding-bottom: 40px;
}

.modal-lecard__footer {
  height: 10%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  padding: 0 16px;
}

.modal-small .modal__inner {
  width: 350px;
}

@media screen and (max-width: 768px) {
  .modal__inner {
    width: 100%!important;
    max-width: none!important;
    min-width: auto!important;
    height: 100%;
    box-sizing: border-box;
  }
}
</style>
